import { FormGroup, FormBuilder } from '@angular/forms';
import { FormCd001LimpezaBuild } from './forms-build/form-cd001-build-limpeza';

export class FormCd001Limpeza extends FormCd001LimpezaBuild {
    public createFormLimpeza(formBuilder: FormBuilder): FormGroup {
        const formulario: FormGroup = formBuilder.group({
            id: [0, []],
            site: ['', []],
            data_hora: ['', []],
            numero_controle: ['', []],
            hibrido: ['', []],
            processo: ['', []],
            lote_origem: ['', []],
            deposito_origem: ['', []],
            umidade_ds_prc: ['', []],
            safra: ['', []],
            peneira_topo: ['', []],
            peneira_fundo: ['', []],
            peneira_intermediaria: ['', []],
            peso_amostra_dez_segundos_kg: ['', []],
            vazao_processo_th: ['', []],
            peso_amostra_trinta_segundos_g: ['', []],
            peso_fracao_analise_g: ['', []],
            peso_semente_boa_descarte_g: ['', []],
            descarte_total_pre_limpeza_prc: ['', []],
            perda_semente_boa_descarte_prc: ['', []],
            perda_descarte_prc: ['', []],
            total_defeitos_prc: ['', []],
            total_defeitos_g: ['', []],
            peso_hectolitrico_fracao_boa: ['', []],
            peso_hectolitrico_fracao_descarte: ['', []],
            diferenca_peso_hectolitrico: ['', []],
            presenca_sabugo_pedunculo: ['', []],
            presenca_fundo: ['', []],
            presenca_po_excesso: ['', []],
            presenca_outros_cultivares: ['', []],
            created_by: ['', []],
            usuario: ['', []],
            observacoes: ['', []],
            offline: true,
            basic: ['', []],
            peso_pre_pos_succsao: ['', []],
            peso_topo_fundo_30s: ['', []],
            descarte_kg_h: ['', []],
            numero_campo: ['', []],
            ajuste_1: [null, []],
            ajuste_2: [null, []],
            ajuste_3: [null, []],
            ajuste_4: [null, []],
            ajuste_5: [null, []],
            ajuste_6: [null, []],
            peso_amostra_cinco_segundos_kg: [null, []],
            resultado: [null, []],
            existe_descarte_massa_boa: [null, []],
            turno: [null, []],

        });
        return formulario;
    }
}
